<div class="content-wrapper container-xxl p-0" xmlns="http://www.w3.org/1999/html">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row">
      <!--DEAL DETAIL SECTION-->
      <section class="col-12" id="section2" *ngIf="typeDeal">
        <div class="card" [ngClass]="activeTab === 'deal_detail' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('deal_detail')">
            <h3 *ngIf="typeDeal === 'Task'">{{ "DETAIL_OFFER_TASK" | translate }}</h3>
            <h3 *ngIf="typeDeal === 'Time Material'">{{ "DETAIL_OFFER_TIME_MATERIAL" | translate }}</h3>
          </div>
          <div [ngClass]="activeTab === 'deal_detail' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row" [formGroup]="formGroupDetail">
              <div class="col-12 my-1">
                <h4>{{ "CUSTOMER_INFORMATION" | translate }}</h4>
              </div>
              <div class="form-group col-12 col-xl-4">
                <label for="customer">{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="customer"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="customer"
                  [placeholder]="'PLACEHOLDER.SELECT_CUSTOMER' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('customer') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="customers_list"
                  (change)="scrollToDocumentSection(); changeCustomerInformation($any($event))"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.CUSTOMER_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-4">
                <label for="customer_site">{{ "OFFICE_SITE" | translate }}</label>
                <ng-select
                  id="customer_site"
                  bindLabel="label"
                  bindValue="id"
                  formControlName="office_site"
                  [placeholder]="'PLACEHOLDER.SELECT_SITE' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [readonly]="!formGroupDetail.value.customer"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="filtered_customers_site_list"
                  (change)="scrollToDocumentSection()"
                  class="{{ fieldHasErrors('office_site') ? 'is-invalid' : '' }}"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_OFFICE_SITE" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-4">
                <div class="d-flex justify-content-between">
                  <label for="customer_referent">{{ "CUSTOMER_REFERENCE" | translate }}</label>
                  <label *ngIf="formGroupDetail.value.customer && _authService.hasCapability('create_customer_referent')" class="cursor-pointer text-primary" (click)="toggleModalAdd = true">{{
                    "ADD_NEW_CUSTOMER_REFERENCE" | translate
                  }}</label>
                </div>
                <ng-select
                  id="customer_referent"
                  bindLabel="complete_name"
                  bindValue="id"
                  formControlName="referent_id"
                  [placeholder]="'PLACEHOLDER.SELECT_REFERENT' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [readonly]="!formGroupDetail.value.customer"
                  [clearable]="true"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="filtered_referents_list"
                ></ng-select>
              </div>
              <div class="col-12 my-1">
                <h4>{{ "DEAL_INFORMATION" | translate }}</h4>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
                <input class="form-control {{ fieldHasErrors('name') ? 'is-invalid' : '' }}" id="name" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" (change)="scrollToDocumentSection()" />
                <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="object">{{ "OBJECT" | translate }}<sup class="text-danger">*</sup></label>
                <input class="form-control {{ fieldHasErrors('object') ? 'is-invalid' : '' }}" id="object" formControlName="object" (change)="scrollToDocumentSection()" />
                <div class="invalid-feedback">{{ "ERRORS.INSERT_OBJECT" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="employee">{{ "TITLES.USERS_TYPES.employee" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="employee"
                  bindLabel="complete_name"
                  bindValue="hash"
                  formControlName="employee"
                  [hideSelected]="true"
                  [placeholder]="'PLACEHOLDER.SELECT_ONE_OR_MORE_EMPLOYEE' | translate"
                  [multiple]="true"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('employee') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="employees_list"
                  (change)="scrollToDocumentSection(); fillDataTableEmployeeArray()"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.EMPLOYEES_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="commercial">{{ "CUSTOMER_COMMERCIAL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="commercial"
                  bindLabel="complete_name"
                  bindValue="hash"
                  formControlName="commercial"
                  [placeholder]="'PLACEHOLDER.SELECT_COMMERCIAL' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('commercial') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="commercial_list"
                  (change)="scrollToDocumentSection()"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_COMMERCIAL" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <app-datepickr
                  id="start_date"
                  (onSelect)="takeDate($event, 'start_date'); calculateDifferenceInMonth(); scrollToDocumentSection()"
                  [minDateToday]="setMinDateToday"
                  [isInvalid]="!formGroupDetail.value.start_date && showErrors"
                ></app-datepickr>
                <div class="invalid-date" *ngIf="!formGroupDetail.value.start_date && showErrors">{{ "ERRORS.INSERT_START_DATE" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="end_date">{{ "END_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <app-datepickr
                  id="end_date"
                  (onSelect)="takeDate($event, 'end_date'); calculateDifferenceInMonth(); scrollToDocumentSection()"
                  [minDateToday]="setMinDateToday"
                  [isInvalid]="!formGroupDetail.value.end_date && showErrors"
                ></app-datepickr>
                <div class="invalid-date" *ngIf="!formGroupDetail.value.end_date && showErrors">{{ "ERRORS.INSERT_END_DATE" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="billing_frequency">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="billing_frequency"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="billing_frequency"
                  [placeholder]="'PLACEHOLDER.SELECT_BILLING_FREQUENCY' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="billingFrequencyList"
                  (change)="calculateDifferenceInMonth(); scrollToDocumentSection()"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="tranche_number">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  class="form-control {{ fieldHasErrors('tranche_number') || formGroupDetail?.value?.tranche_number === 0 ? 'is-invalid' : '' }}"
                  id="tranche_number"
                  [placeholder]="'PLACEHOLDER.INSERT_TRANCHE_NUMBER' | translate"
                  type="number"
                  formControlName="tranche_number"
                  (change)="scrollToDocumentSection()"
                />
                <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
              </div>
            </div>
            <!--END FORM DEAL DETAIL-->
          </div>
        </div>
      </section>

      <!--DEAL PREVENTIVE SECTION-->
      <section class="col-12" id="section3" *ngIf="typeDeal && isDetailSectionCompleted">
        <div class="card" [ngClass]="activeTab === 'deal_document' ? 'active' : ''" [formGroup]="formGroupBoxes">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('deal_document')">
            <h3>{{ "DEAL_DOCUMENT" | translate }}</h3>
          </div>
          <div [ngClass]="activeTab === 'deal_document' ? 'card-body pb-0' : 'd-none'">
            <!--BOX 1-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4 *ngIf="typeDeal === 'Task'">1. {{ "SUPPLY_OBJCET" | translate }}</h4>
                <h4 *ngIf="typeDeal === 'Time Material'">1. {{ "SUPPLY_DESCRIPTION" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_1" [formControlName]="'box_1'"></textarea>
              </div>
            </div>
            <!--Box 2-->
            <div class="row">
              <div [class]="'form-group col-12'">
                <h4>2. {{ "ECONOMIC_OFFER" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_2" [formControlName]="'box_2'"></textarea>
                <p class="font-small-3">{{ "LEGEND_TABLECONTENT" | translate }}</p>
                <!-- DATA TABLE TASK -->
                <div class="card-body px-0 pb-0" *ngIf="typeDeal === 'Task'">
                  <table class="tg col-12">
                    <thead>
                      <tr>
                        <th class="tg-0lax">
                          {{ "ACTIVITY" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.activity_name = false" *ngIf="columnTableTask?.activity_name" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.activity_name = true" *ngIf="!columnTableTask?.activity_name" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DURATION_SINGLE" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.contract_duration = false" *ngIf="columnTableTask?.contract_duration" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.contract_duration = true" *ngIf="!columnTableTask?.contract_duration" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "MONTHS" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.months_number = false" *ngIf="columnTableTask?.months_number" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.months_number = true" *ngIf="!columnTableTask?.months_number" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "MONTHLY_CANON" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.monthly_canon = false" *ngIf="columnTableTask?.monthly_canon" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.monthly_canon = true" *ngIf="!columnTableTask?.monthly_canon" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }} <sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTableTask.employee_name = false" *ngIf="columnTableTask?.employee_name" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.employee_name = true" *ngIf="!columnTableTask?.employee_name" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DAILY_RATE" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.daily_rate = false" *ngIf="columnTableTask?.daily_rate" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.daily_rate = true" *ngIf="!columnTableTask?.daily_rate" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "SINGLE_AMOUNT" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTableTask.line_amount = false" *ngIf="columnTableTask?.line_amount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate"
                            ><i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.line_amount = true" *ngIf="!columnTableTask?.line_amount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DISCOUNTED_AMOUNT" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTask.discount = false" *ngIf="columnTableTask?.discount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTask.discount = true" *ngIf="!columnTableTask?.discount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">{{ "ACTIONS" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of taskTablesRows; let i = index">
                        <td class="text-center">{{ row.activity_name }}</td>
                        <td class="text-center">{{ row.contract_duration }}</td>
                        <td class="text-center">{{ row.months_number }}</td>
                        <td class="text-center">{{ row.monthly_canon }}</td>
                        <td class="text-center">{{ row.employee_name }}</td>
                        <td class="text-center"><span *ngIf="row.daily_rate">€. </span>{{ row.daily_rate }}</td>
                        <td class="text-center"><span *ngIf="row.line_amount">€. </span>{{ row.line_amount }}</td>
                        <td class="text-center"><span *ngIf="row.discount">€. </span>{{ row.discount }}</td>
                        <td class="text-center">
                          <div>
                            <button (click)="modalOpen(modalTask, row, i)" type="button" class="btn btn-circle btn-sm" rippleEffect>
                              <i class="ml-025 text-primary" [data-feather]="'edit-2'" size="19"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-right mt-1" *ngIf="taskTablesRows && taskTablesRows.length >= 1">
                    <div *ngIf="taskTablesRows[0].total_deal">
                      <strong>{{ "TOTAL_SINGULAR" | translate }}: </strong> <span>€. </span>{{ taskTablesRows[0].total_deal }}
                    </div>
                    <div *ngIf="taskTablesRows[0].total_discounted_deal">
                      <strong>{{ "TOTAL_DISCOUNTED_AMOUNT" | translate }}: </strong> <span>€. </span>{{ taskTablesRows[0].total_discounted_deal }}
                    </div>
                  </div>
                </div>
                <!-- DATA TABLE TIMEMATERIAL -->
                <div class="card-body px-0 pb-0" *ngIf="typeDeal === 'Time Material'">
                  <table class="tg col-12">
                    <thead>
                      <tr>
                        <th class="tg-0lax">
                          {{ "FIGURE" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.figure_id = false" *ngIf="columnTableTimeMaterial?.figure_id" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.figure_id = true" *ngIf="!columnTableTimeMaterial?.figure_id" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "PERIOD" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.period = false" *ngIf="columnTableTimeMaterial?.period" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.period = true" *ngIf="!columnTableTimeMaterial?.period" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "EFFORT" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.total_effort = false" *ngIf="columnTableTimeMaterial?.total_effort" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.total_effort = true" *ngIf="!columnTableTimeMaterial?.total_effort" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.employee_name = false" *ngIf="columnTableTimeMaterial?.employee_name" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.employee_name = true" *ngIf="!columnTableTimeMaterial?.employee_name" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DAILY_RATE" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.daily_rate = false" *ngIf="columnTableTimeMaterial?.daily_rate" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.daily_rate = true" *ngIf="!columnTableTimeMaterial?.daily_rate" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "SINGLE_AMOUNT" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.line_amount = false" *ngIf="columnTableTimeMaterial?.line_amount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate"
                            ><i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.line_amount = true" *ngIf="!columnTableTimeMaterial?.line_amount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DISCOUNTED_AMOUNT" | translate }}
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.discount = false" *ngIf="columnTableTimeMaterial?.discount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTableTimeMaterial.discount = true" *ngIf="!columnTableTimeMaterial?.discount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">{{ "ACTIONS" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of timeMaterialTablesRows; let i = index">
                        <td class="text-center">{{ row.figure_name }}</td>
                        <td class="text-center">{{ row.period }}</td>
                        <td class="text-center">{{ row.total_effort }}</td>
                        <td class="text-center">{{ row.employee_name }}</td>
                        <td class="text-center"><span *ngIf="row.daily_rate">€. </span>{{ row.daily_rate }}</td>
                        <td class="text-center"><span *ngIf="row.line_amount">€. </span>{{ row.line_amount }}</td>
                        <td class="text-center"><span *ngIf="row.discount">€. </span>{{ row.discount }}</td>
                        <td class="text-center">
                          <div>
                            <button (click)="modalOpen(modalTimeMaterial, row, i)" type="button" class="btn btn-circle btn-sm" rippleEffect>
                              <i class="ml-025 text-primary" [data-feather]="'edit-2'" size="19"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-right mt-1" *ngIf="timeMaterialTablesRows && timeMaterialTablesRows.length >= 1">
                    <div *ngIf="timeMaterialTablesRows[0].total_deal">
                      <strong>{{ "TOTAL_SINGULAR" | translate }}: </strong> <span>€. </span>{{ timeMaterialTablesRows[0].total_deal }}
                    </div>
                    <div *ngIf="timeMaterialTablesRows[0].total_discounted_deal">
                      <strong>{{ "TOTAL_DISCOUNTED_AMOUNT" | translate }}: </strong> <span>€. </span>{{ timeMaterialTablesRows[0].total_discounted_deal }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Box 3-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>3. {{ "JOB_SITE_AND_TIMETABLES" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_3" [formControlName]="'box_3'"></textarea>
              </div>
            </div>
            <!--Box 4-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>4. {{ "LEGAL_OBLIGATIONS" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_4" [formControlName]="'box_4'"></textarea>
              </div>
            </div>
            <!--Box 5-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>5. {{ "PRIVACY" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_5" [formControlName]="'box_5'"></textarea>
              </div>
            </div>
            <!--Box 6-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>6. {{ "FACTURATION_MODE" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_6" [formControlName]="'box_6'"></textarea>
              </div>
            </div>
            <!--Box 7-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>7. {{ "PAYAMENT_TERMS" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_7" [formControlName]="'box_7'"></textarea>
              </div>
            </div>
            <!--Box 8-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>8. {{ "VALID_OFFFER" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_8" [formControlName]="'box_8'"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="row" *ngIf="isDetailSectionCompleted && _authService.hasCapability('create_deal')">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary text-primary mb-4" (click)="create()">{{ "SAVE" | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Task -->
<ng-template #modalTask let-modal>
  <form [formGroup]="formGroupTask">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ADD_ROW_TABLE" | translate }}</h3>
      <div class="row">
        <div class="form-group col-12">
          <label for="employee_hash_task">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
          <select class="form-control" id="employee_hash_task" formControlName="employee_hash">
            <option [value]="employee.hash" *ngFor="let employee of employees_list_datatable">{{ employee.complete_name }}</option>
          </select>
        </div>
        <div class="form-group col-12">
          <label for="activity_name_task">{{ "ACTIVITY_NAME" | translate }}</label>
          <textarea id="activity_name_task" [placeholder]="'ACTIVITY_PLACEHOLDER' | translate" type="text" class="form-control" rows="4" formControlName="activity_name"></textarea>
        </div>
        <div class="form-group col-12">
          <label for="contract_duration_task">{{ "CONTRACT_DURATION" | translate }}</label>
          <input id="contract_duration_task" type="text" class="form-control" formControlName="contract_duration" />
        </div>
        <div class="form-group col-12">
          <label for="daily_rate_task">{{ "DAILY_RATE" | translate }}</label>
          <input id="daily_rate_task" placeholder="100,00" type="text" class="form-control" formControlName="daily_rate" (change)="formatMoneyValue($any($event.target).value, 'daily_rate')" />
        </div>
        <div class="form-group col-12">
          <label for="months_task">{{ "MONTHS" | translate | titlecase }}</label>
          <input id="months_task" placeholder="1" type="number" class="form-control" min="1" max="12" formControlName="months_number" (change)="calculateLineAmountTask(formGroupTask.value.monthly_canon)" />
        </div>
        <div class="form-group col-12">
          <label for="monthly_canon_task">{{ "MONTHLY_CANON" | translate }}</label>
          <input id="monthly_canon_task" placeholder="3.000,00" type="text" class="form-control" formControlName="monthly_canon" (change)="formatMoneyValue($any($event.target).value, 'monthly_canon')" />
          <div class="font-small-1">{{ "DESCRIPTION_MONTHLY_CANON" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="line_amount_task">{{ "AMOUNT" | translate }}<sup class="text-danger">*</sup></label>
          <input id="line_amount_task" placeholder="3.000,00" type="text" class="form-control" formControlName="line_amount" (change)="formatMoneyValue($any($event.target).value, 'line_amount')" />
        </div>
        <div class="form-group col-12">
          <label for="discount_task">{{ "DISCOUNTED_AMOUNT" | translate }}</label>
          <input id="discount_task" placeholder="1.500,00" type="text" class="form-control" formControlName="discount" (change)="formatMoneyValue($any($event.target).value, 'discount')" />
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "BACK" | translate }}
      </button>
      <button type="button" class="btn btn-primary w-150" (click)="editRow()" rippleEffect>
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Task -->

<!-- Modal Time Material -->
<ng-template #modalTimeMaterial let-modal>
  <form [formGroup]="formGroupTimeMaterial">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ADD_ROW_TABLE" | translate }}</h3>
      <div class="row">
        <div class="form-group col-12">
          <label for="employee_hash_time_material">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
          <select class="form-control" id="employee_hash_time_material" formControlName="employee_hash">
            <option [value]="employee.hash" *ngFor="let employee of employees_list_datatable">{{ employee.complete_name }}</option>
          </select>
        </div>
        <div class="form-group col-12">
          <label for="figure_time_material">{{ "FIGURE" | translate }}</label>
          <select class="form-control" id="figure_time_material" formControlName="figure_id">
            <option *ngFor="let figure of figures_list" [value]="figure.id">{{ figure.name }}</option>
          </select>
        </div>
        <div class="form-group col-12">
          <label for="contract_duration_time_material">{{ "PERIOD" | translate }}</label>
          <input id="contract_duration_time_material" type="text" class="form-control" formControlName="period" />
        </div>
        <div class="form-group col-12">
          <label for="months_time_material">{{ "EFFORT" | translate | titlecase }}</label>
          <input id="months_time_material" placeholder="30" type="text" class="form-control" (change)="calculateLineAmountTimeMaterial($any($event.target).value)" formControlName="total_effort" />
        </div>
        <div class="form-group col-12">
          <label for="daily_rate_time_material">{{ "DAILY_RATE" | translate }}<sup class="text-danger">*</sup></label>
          <input id="daily_rate_time_material" placeholder="100,00" type="text" class="form-control" formControlName="daily_rate" (change)="formatMoneyValue($any($event.target).value, 'daily_rate')" />
        </div>
        <div class="form-group col-12">
          <label for="line_amount_time_material">{{ "AMOUNT" | translate }}<sup class="text-danger">*</sup></label>
          <input id="line_amount_time_material" placeholder="3.000,00" type="text" class="form-control" formControlName="line_amount" (change)="formatMoneyValue($any($event.target).value, 'line_amount')" />
        </div>
        <div class="form-group col-12">
          <label for="discount_time_material">{{ "DISCOUNTED_AMOUNT" | translate }}</label>
          <input id="discount_time_material" placeholder="1.500,00" type="text" class="form-control" formControlName="discount" (change)="formatMoneyValue($any($event.target).value, 'discount')" />
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "BACK" | translate }}
      </button>
      <button type="button" class="btn btn-primary w-150" (click)="editRow()" rippleEffect>
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Time Material -->

<!-- Modal ADD -->
<app-form-add-customer-referent
  *ngIf="toggleModalAdd && _authService.hasCapability('create_customer_referent')"
  (callbackFn)="toggleModalAdd = false"
  (onAdd)="onReferentModalFormEvent($event)"
  [clientID]="formGroupDetail.value.customer"
></app-form-add-customer-referent>
<!-- / Modal ADD -->
